export default "__VITE_ASSET__BUkSrLGP__"